'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$(outer) {
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ as $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ };
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ as $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ };
$h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$.prototype = $p;
var $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$, "com.raquo.laminar.keys.CompositeKey$CompositeValueMappers$StringValueMapper$", ({
  ii: 1,
  ih: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ as $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ };
